/*global Modernizr, mobility_express_rate_directions, mobility_express_tpn_map, mobility_express_fetch_rates, mobility_express_toll_point_data, mobility_express_sum_rates, mobility_express_rate_format_money, flatpickr, console */
/*jslint browser:true */

(function() {
  'use strict';

  var button_text = '',
      rate_containers = document.querySelectorAll('.js-historical-rate');

  rate_containers.forEach((rate_container) => {
    var rate_facility = rate_container.getAttribute('data-facility'),
        rate_sign = rate_container.querySelector('.rate-sign'),
        rate_filter_date = rate_container.querySelector('.historical-rate-date'),
        rate_filter_date_error = rate_container.querySelector('.historical-rate-date-error'),
        rate_filter_direction = rate_container.querySelector('.historical-rate-direction'),
        rate_filter_entry = rate_container.querySelector('.historical-rate-entry'),
        rate_filter_submit = rate_container.querySelector('.historical-rate-submit'),
        rate_error = rate_container.querySelector('.historical-rate-error');

    if(!mobility_express_rate_directions.hasOwnProperty(rate_facility)) {
      console.error('Facility information is not setup.');
      return;
    }

    if(!mobility_express_tpn_map.hasOwnProperty(rate_facility)) {
      console.error('Facility TPN information is not setup.');
      return;
    }

    var facility_rate_directions = mobility_express_rate_directions[rate_facility],
        facility_tpn_map = mobility_express_tpn_map[rate_facility];

    // Setup date picker
    flatpickr(rate_filter_date, {
      enableTime: true,
      altInput: true,
      altFormat: 'm-d-Y h:i K',
      dateFormat: 'm/d/Y H:i'
    });

    // Set initial entries
    facility_rate_directions[rate_filter_direction.value].forEach((entry) => {
      var option = document.createElement("option");
      option.text = entry.name;
      option.value = entry.value;

      rate_filter_entry.appendChild(option);
    });

    // Listen for direction dropdown to change to rebuild entry options
    rate_filter_direction.addEventListener('change', () => {
      rate_filter_entry.innerHTML = '';

      if(!facility_rate_directions.hasOwnProperty(rate_filter_direction.value)) {
        rate_filter_direction.value = 'sb';
      }

      facility_rate_directions[rate_filter_direction.value].forEach((entry) => {
        var option = document.createElement("option");
        option.text = entry.name;
        option.value = entry.value;

        rate_filter_entry.appendChild(option);
      });
    });

    // Load rates and update sign
    rate_filter_submit.addEventListener('click', (e) => {
      e.preventDefault();

      rate_error.classList.add('hide');

      button_text = rate_filter_submit.querySelector('span').innerText;
      rate_filter_submit.classList.add('disabled');
      rate_filter_submit.querySelector('span').innerText = 'Loading...';

      // Check if date is empty
      if(rate_filter_date.value === '') {
        rate_filter_date.parentNode.parentNode.classList.add('gfield_error');
        rate_filter_date_error.classList.remove('hide');
        return;
      } else {
        rate_filter_date.parentNode.parentNode.classList.remove('gfield_error');
        rate_filter_date_error.classList.add('hide');
      }

      var facilities = [rate_facility];

      facility_tpn_map[rate_filter_entry.value].tollPoints.forEach((tollingPoint, index) => {
        if(typeof tollingPoint === 'object') {
          if(tollingPoint.hasOwnProperty('facility') && !facilities.includes(tollingPoint.facility)) {
            facilities.push(tollingPoint.facility);
          }

          if(tollingPoint.hasOwnProperty('include') && tollingPoint.include.hasOwnProperty('facility') && !facilities.includes(tollingPoint.include.facility)) {
            facilities.push(tollingPoint.include.facility);
          }
        }
      });

      mobility_express_fetch_rates(facilities, rate_filter_date.value, (data) => {
        rate_filter_submit.classList.remove('disabled');
        rate_filter_submit.querySelector('span').innerText = button_text;

        buildRates(rate_sign, rate_filter_entry.value, facility_tpn_map, data);
      }, () => {
        rate_error.classList.remove('hide');
        rate_filter_submit.classList.remove('disabled');
        rate_filter_submit.querySelector('span').innerText = button_text;
      });
    });
  });

  function updateSign(sign, signClass, rates) {
    sign.innerHTML = '';
    sign.className = 'rate-sign auto-scale';

    if(rates === 0) {
      sign.classList.add('no-sign');
      return;
    }

    sign.classList.add(signClass);

    rates.forEach((rate, index) => {
      sign.insertAdjacentHTML('beforeend', '<div style="color: ' + ((rate.rate === 'CLOSED') ? 'red' : 'white') + ';" class="price-box price-box-' + (index + 1) + '">' + rate.rate + '</div>');
      sign.insertAdjacentHTML('beforeend', '<div style="color: ' + ((rate.pbm === 'CLOSED') ? 'red' : 'white') + ';" class="price-box-pbm price-box-pbm-' + (index + 1) + '">' + rate.pbm + '</div>');
    });
  }

  function buildRates(rate_sign, rate_filter_entry, facility_tpn_map, data) {
    var sign_information = [];

    facility_tpn_map[rate_filter_entry].tollPoints.forEach((tollingPoint, index) => {
      var tollingPointData,
          tolling_point_is_object = false;

      if(typeof tollingPoint === 'object') {
        tolling_point_is_object = true;

        tollingPointData = tollingPoint;
        tollingPoint = tollingPointData.tollPoint;
      }

      tollingPoint = data.find((include_datum) => include_datum.tollingPointName === tollingPoint);
      if(tollingPoint) {
        var clean = mobility_express_toll_point_data(tollingPoint);

        if(tolling_point_is_object) {
          if(tollingPointData.hasOwnProperty('include')) {
            var include_point = data.find((include_datum) => include_datum.tollingPointName === tollingPointData.include.tollPoint);
            if(include_point) {
              clean = mobility_express_sum_rates(clean, mobility_express_toll_point_data(include_point));
            }
          }
        }

        sign_information.push(clean);
      }
    });

    updateSign(rate_sign, facility_tpn_map[rate_filter_entry].signClass, sign_information);
  }
}());